import { render, staticRenderFns } from "./ImageEraser.vue?vue&type=template&id=30c6f60c&scoped=true&"
import script from "./ImageEraser.vue?vue&type=script&lang=ts&"
export * from "./ImageEraser.vue?vue&type=script&lang=ts&"
import style0 from "./ImageEraser.vue?vue&type=style&index=0&id=30c6f60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c6f60c",
  null
  
)

export default component.exports